/**
 * Origens permitidas da ingestao externa (ADR-0063) — funcoes puras.
 *
 * Espelha `formularios.services.normalizar_origem` do backend: esquema +
 * host + porta NAO padrao, em minusculas. O browser nunca escreve `:443`
 * (https) nem `:80` (http) no header `Origin`, entao uma origem gravada
 * com a porta padrao nunca casava (FORM-51).
 */

const PORTA_PADRAO = { "https:": "443", "http:": "80" };

/** `https://www.site.com.br:443/x` -> `https://www.site.com.br`; "" quando nao e' origem. */
export function normalizarOrigem(valor) {
  const texto = String(valor ?? "").trim();
  if (!texto) return "";
  let url;
  try {
    url = new URL(texto.includes("//") ? texto : `https://${texto}`);
  } catch {
    return "";
  }
  if (!url.hostname) return "";
  const porta = url.port && url.port !== PORTA_PADRAO[url.protocol] ? `:${url.port}` : "";
  return `${url.protocol}//${url.hostname}${porta}`.toLowerCase();
}

export function mesmaOrigem(a, b) {
  const na = normalizarOrigem(a);
  return Boolean(na) && na === normalizarOrigem(b);
}

const PREFIXO_WWW = "www.";

/** A outra forma do mesmo dominio: com www <-> sem www. "" quando nao se aplica (IP, localhost). */
export function varianteWww(origem) {
  const normalizada = normalizarOrigem(origem);
  if (!normalizada) return "";
  const url = new URL(normalizada);
  const host = url.hostname;
  if (/^[\d.]+$/.test(host) || host.includes(":") || !host.includes(".")) return "";
  const outroHost = host.startsWith(PREFIXO_WWW)
    ? host.slice(PREFIXO_WWW.length)
    : `${PREFIXO_WWW}${host}`;
  if (!outroHost.includes(".")) return "";
  return `${url.protocol}//${outroHost}${url.port ? `:${url.port}` : ""}`;
}

/**
 * Variantes (com/sem www) que faltam na lista, sem repetir.
 *
 * `www.site.com.br` e `site.com.br` sao origens DIFERENTES para o browser:
 * o fetch do apex falha por CORS se so o www estiver cadastrado. A tela
 * oferece adicionar a que falta.
 */
export function variantesWwwFaltantes(origens) {
  const cadastradas = new Set((origens || []).map(normalizarOrigem).filter(Boolean));
  const faltantes = [];
  cadastradas.forEach((origem) => {
    const outra = varianteWww(origem);
    if (outra && !cadastradas.has(outra) && !faltantes.includes(outra)) faltantes.push(outra);
  });
  return faltantes;
}
